import { IconWithText } from '@pkdigital/pkd-custom-components';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useBranding } from '../../hooks/useBranding';

export const DesktopCards = () => {
  const { t } = useTranslation();
  const branding = useBranding();

  return (
    <Row className={'gx-100'}>
      <Col md={4} className={'col-gap-3'}>
        <div className={`advantages-card ${branding === 'hug' ? 'advantages-card-blue' : ''}`}>
          <IconWithText
            icon={['pkd', 'calendar-clock-light']}
            text={t('advantagesSection.cards.c1.title')}
          />
          <div className={'mt-3'}>{t('advantagesSection.cards.c1.content')}</div>
        </div>
      </Col>

      <Col md={4}>
        <div className={`advantages-card ${branding === 'hug' ? 'advantages-card-blue' : ''}`}>
          <IconWithText
            icon={['pkd', 'check-light']}
            text={t('advantagesSection.cards.c2.title')}
          />
          <div className="mt-3">{t('advantagesSection.cards.c2.content')}</div>
        </div>
      </Col>

      <Col md={4}>
        <div className={`advantages-card ${branding === 'hug' ? 'advantages-card-blue' : ''}`}>
          <IconWithText
            icon={['pkd', 'euro-sign-light']}
            text={t('advantagesSection.cards.c3.title')}
          />
          <div className="mt-3">{t('advantagesSection.cards.c3.content')}</div>
        </div>
      </Col>

      <Col md={4}>
        <div className={`advantages-card ${branding === 'hug' ? 'advantages-card-blue' : ''}`}>
          <IconWithText
            icon={['pkd', 'laptop-file-light']}
            text={t('advantagesSection.cards.c4.title')}
          />
          <div className="mt-3">{t('advantagesSection.cards.c4.content')}</div>
        </div>
      </Col>

      <Col md={4}>
        <div className={`advantages-card ${branding === 'hug' ? 'advantages-card-blue' : ''}`}>
          <IconWithText
            icon={['pkd', 'helmet-safety-light']}
            text={t('advantagesSection.cards.c5.title')}
          />
          <div className="mt-3">{t('advantagesSection.cards.c5.content')}</div>
        </div>
      </Col>

      <Col md={4}>
        <div className={`advantages-card ${branding === 'hug' ? 'advantages-card-blue' : ''}`}>
          <IconWithText
            icon={['pkd', 'shield-check-light']}
            text={t('advantagesSection.cards.c6.title')}
          />
          <div className="mt-3">{t('advantagesSection.cards.c6.content')}</div>
        </div>
      </Col>
    </Row>
  );
};
